import { SINGLE_LOCATION_FETCH_REQUEST, SINGLE_LOCATION_FETCH_SUCCESS, SINGLE_LOCATION_FETCH_FAILURE } from './types';
import baseUrl from '../url'

const fetchSingleLocationRequest = () => {
    return {
        type: SINGLE_LOCATION_FETCH_REQUEST
    }
}

const fetchSingleLocationSuccess = location => {
    return {
        type: SINGLE_LOCATION_FETCH_SUCCESS,
        payload: location,
    }
}

const fetchSingleLocationFailure = error => {
    return {
        type: SINGLE_LOCATION_FETCH_FAILURE,
        payload: error,
    }
}

export const getSingleLocation = (locationSlug) => {
    if (locationSlug) {
        return (dispatch) => {
            dispatch(fetchSingleLocationRequest());
            fetch(`${baseUrl}/shoot_locations/${locationSlug}`, {
                    method: 'GET'
                })
                .then(response => response.json())
                .then((response) => {
                    dispatch(fetchSingleLocationSuccess(response));
                })
                .catch((error) => {
                    dispatch(fetchSingleLocationFailure(error.message));
                })
        }
    } else {
        return (dispatch) => { dispatch(fetchSingleLocationSuccess({})); }
    }
}